import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { devices } from 'styles/devices';

const WrapperTemplate = ({ children, className }) => (
   <Wrapper className={className}>{children}</Wrapper>
);

const Wrapper = styled.div`
   width: 100%;
   padding: 20px;

   ${devices.tabletL} {
      padding: 0 60px;
   }

   ${devices.tabletXL} {
      padding: 0 100px;
   }
`;

WrapperTemplate.propTypes = {
   children: PropTypes.node.isRequired,
   className: PropTypes.string.isRequired
};

export default WrapperTemplate;
